import { DASH } from "@/constants/testIds";

export default function BudgetAlert({ budget }) {
  if (!budget || !budget.enabled) return null;
  const over = budget.over_budget;
  const pct = Math.min(100, Math.max(0, budget.pct_of_budget || 0));

  return (
    <div
      data-testid={DASH.budgetAlert}
      className={`flat-card p-6 sm:p-7 border-l-4 ${over ? "border-l-[#B24F35]" : "border-l-[#8FA38B]"}`}
    >
      <div className="flex items-start justify-between flex-wrap gap-3">
        <div>
          <div className="overline mb-2">Budget · This month</div>
          <div className="font-display text-lg">
            {over ? "You're over budget." : "You're on track."}
          </div>
          <div className="text-sm text-[#6E716C] mt-1 font-mono-data">
            RM {budget.latest_cost_rm.toFixed(2)} of RM {budget.budget_rm.toFixed(2)} · {budget.pct_of_budget.toFixed(1)}%
          </div>
        </div>
        <div className="w-full sm:w-64">
          <div className="h-2 bg-[#F0F0EA] w-full">
            <div
              className={`h-2 ${over ? "bg-[#B24F35]" : "bg-[#0F3524]"} transition-all`}
              style={{ width: `${Math.min(100, pct)}%` }}
            />
          </div>
          {over && (
            <div className="text-xs text-[#B24F35] font-mono-data mt-2">
              RM {(budget.latest_cost_rm - budget.budget_rm).toFixed(2)} over
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
